import { QRCodeSVG } from 'qrcode.react';

interface QRGeneratorProps {
  url: string;
  size?: number;
}

export function QRGenerator({ url, size = 256 }: QRGeneratorProps) {
  const handleDownload = () => {
    const svg = document.getElementById('qr-code');
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    canvas.width = size;
    canvas.height = size;

    img.onload = () => {
      // No limpiar el canvas para mantener transparencia
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'LIEC-QR-Code.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  return (
    <div className="flex flex-col items-center gap-4 p-8 bg-white rounded-lg shadow-xl">
      <h2 className="text-2xl font-bold text-[#0052A3]">Código QR - LIEC Links</h2>
      <div className="p-4 bg-white rounded-lg border-4 border-[#0052A3]">
        <QRCodeSVG
          id="qr-code"
          value={url}
          size={size}
          level="H"
          includeMargin={true}
          bgColor="transparent"
          fgColor="#000000"
        />
      </div>
      <button
        onClick={handleDownload}
        className="px-6 py-3 bg-[#0052A3] text-white font-semibold rounded-lg hover:bg-[#003d7a] transition-colors"
      >
        Descargar QR
      </button>
      <p className="text-sm text-gray-600 text-center max-w-md">
        Escanea este código QR para acceder a todos los enlaces de LIEC
      </p>
    </div>
  );
}
